<template>
<v-card flat>

    <editor-menu-bar :editor="editor">

        <div slot-scope="{ commands, isActive, getMarkAttrs, focused }">
            <div class="d-flex flex-wrap" v-if="editable" :class="{'drop-down': true, 'open':  focused}">
                <div>
                    <v-btn @click="commands.undo(), emitInput()" class="bar_button">
                        <v-icon>undo</v-icon>
                    </v-btn>
                    <v-btn @click="commands.redo(), emitInput()" class="bar_button">
                        <v-icon>redo</v-icon>
                    </v-btn>
                </div>

                <v-divider vertical class="mx-2" />

                <div>
                    <v-btn :depressed="isActive.paragraph()" @click="commands.paragraph(), emitInput()" class="bar_button font-weight-bold">P</v-btn>
                    <v-btn :depressed="isActive.heading({ level: 1 })" @click="commands.heading({ level: 1 }), emitInput()" class="bar_button font-weight-bold">H1</v-btn>
                    <v-btn :depressed="isActive.heading({ level: 2 })" @click="commands.heading({ level: 2 }), emitInput()" class="bar_button font-weight-bold">H2</v-btn>
                    <v-btn :depressed="isActive.heading({ level: 3 })" @click="commands.heading({ level: 3 }), emitInput()" class="bar_button font-weight-bold">H3</v-btn>
                    <v-btn :depressed="isActive.heading({ level: 4 })" @click="commands.heading({ level: 4 }), emitInput()" class="bar_button font-weight-bold">H4</v-btn>
                    <v-btn :depressed="isActive.heading({ level: 5 })" @click="commands.heading({ level: 5 }), emitInput()" class="bar_button font-weight-bold">H5</v-btn>
                </div>

                <v-divider vertical class="mx-2" />

                <div class="d-flex flex-wrap">

                    <v-btn :depressed="isActive.bold()" @click="commands.bold(), emitInput()" class="bar_button">
                        <v-icon>format_bold</v-icon>
                    </v-btn>
                    <v-btn :depressed="isActive.italic()" @click="commands.italic(), emitInput()" class="bar_button">
                        <v-icon>format_italic</v-icon>
                    </v-btn>
                    <v-btn :depressed="isActive.strike()" @click="commands.strike(), emitInput()" class="bar_button">
                        <v-icon>format_strikethrough</v-icon>
                    </v-btn>
                    <v-btn :depressed="isActive.underline()" @click="commands.underline(), emitInput()" class="bar_button">
                        <v-icon>format_underlined</v-icon>
                    </v-btn>
                    <v-btn :depressed="isActive.blockquote()" @click="commands.blockquote(), emitInput()" class="bar_button">
                        <v-icon>format_quote</v-icon>
                    </v-btn>
                    <v-btn :depressed="isActive.bullet_list()" @click="commands.bullet_list(), emitInput()" class="bar_button">
                        <v-icon>format_list_bulleted</v-icon>
                    </v-btn>
                    <v-btn :depressed="isActive.ordered_list()" @click="commands.ordered_list(), emitInput()" class="bar_button">
                        <v-icon>format_list_numbered</v-icon>
                    </v-btn>

                    <v-menu v-model="linkMenuIsActive" offset-y :close-on-content-click="false" @submit.prevent="setLinkUrl(commands.link, linkUrl)">

                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" :depressed="isActive.link()" @click="showLinkMenu(getMarkAttrs('link'))" class="bar_button">
                                <v-icon>link</v-icon>
                            </v-btn>
                        </template>

                        <v-card>
                            <div class="d-flex align-center py-0 px-1">
                                <v-text-field solo flat v-model="linkUrl" placeholder="https://" ref="linkInput" hide-details @keydown.esc="hideLinkMenu" />
                                <v-btn flat class="bar_button" @click="setLinkUrl(commands.link, linkUrl), emitInput()">
                                    <v-icon>done</v-icon>
                                </v-btn>
                                <v-btn flat class="bar_button" @click="setLinkUrl(commands.link, null), emitInput()">
                                    <v-icon>clear</v-icon>
                                </v-btn>
                            </div>
                        </v-card>

                    </v-menu>
                </div>

                <v-divider vertical class="mx-2" />

                <div class="d-flex flex-wrap">

                    <v-btn @click="commands.createTable({rowsCount: 3, colsCount: 3, withHeaderRow: false }), emitInput()" class="bar_button">
                        <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 24 24">
                            <path :fill="editable ? 'rgba(0,0,0,1)' : 'rgba(0,0,0,0.26)'" fill-rule="evenodd" d="M17,17 L17,22 L19,22 C20.6568542,22 22,20.6568542 22,19 L22,17 L17,17 Z M15,17 L9,17 L9,22 L15,22 L15,17 Z M17,15 L22,15 L22,9 L17,9 L17,15 Z M15,15 L15,9 L9,9 L9,15 L15,15 Z M17,7 L22,7 L22,5 C22,3.34314575 20.6568542,2 19,2 L17,2 L17,7 Z M15,7 L15,2 L9,2 L9,7 L15,7 Z M24,16.1768671 L24,19 C24,21.7614237 21.7614237,24 19,24 L5,24 C2.23857625,24 2.11453371e-15,21.7614237 1.77635684e-15,19 L0,5 C-3.38176876e-16,2.23857625 2.23857625,2.28362215e-15 5,0 L19,0 C21.7614237,-5.07265313e-16 24,2.23857625 24,5 L24,7.82313285 C24.0122947,7.88054124 24.0187107,7.93964623 24.0187107,8 C24.0187107,8.06035377 24.0122947,8.11945876 24,8.17686715 L24,15.8231329 C24.0122947,15.8805412 24.0187107,15.9396462 24.0187107,16 C24.0187107,16.0603538 24.0122947,16.1194588 24,16.1768671 Z M7,2 L5,2 C3.34314575,2 2,3.34314575 2,5 L2,7 L7,7 L7,2 Z M2,9 L2,15 L7,15 L7,9 L2,9 Z M2,17 L2,19 C2,20.6568542 3.34314575,22 5,22 L7,22 L7,17 L2,17 Z" />
                        </svg>
                    </v-btn>
                    <div class="d-flex flex-wrap" v-if="isActive.table()">
                        <v-btn :disabled="!isActive.table() || !editable" @click="commands.deleteTable(), emitInput()" class="bar_button">
                            <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 24 24">
                                <path :fill="editable ? 'rgba(0,0,0,1)' : 'rgba(0,0,0,0.26)'" d="M19,14 C21.7600532,14.0033061 23.9966939,16.2399468 24,19 C24,21.7614237 21.7614237,24 19,24 C16.2385763,24 14,21.7614237 14,19 C14,16.2385763 16.2385763,14 19,14 Z M16.5,19.9375 L21.5,19.9375 C22.017767,19.9375 22.4375,19.517767 22.4375,19 C22.4375,18.482233 22.017767,18.0625 21.5,18.0625 L16.5,18.0625 C15.982233,18.0625 15.5625,18.482233 15.5625,19 C15.5625,19.517767 15.982233,19.9375 16.5,19.9375 Z M12.2898787,17 L9,17 L9,22 L12.6736312,22 C13.0297295,22.7496048 13.515133,23.4258795 14.1010173,24 L5,24 C2.23857625,24 -1.43817996e-15,21.7614237 -1.77635684e-15,19 L-3.55271368e-15,5 C-3.89089055e-15,2.23857625 2.23857625,5.07265313e-16 5,-1.77635684e-15 L19,-1.77635684e-15 C21.7614237,-2.28362215e-15 24,2.23857625 24,5 L24,7.82313285 C24.0122947,7.88054124 24.0187107,7.93964623 24.0187107,8 C24.0187107,8.06035377 24.0122947,8.11945876 24,8.17686715 L24,14.1010173 C23.4258795,13.515133 22.7496048,13.0297295 22,12.6736312 L22,9 L17,9 L17,12.2898787 C16.2775651,12.5048858 15.6040072,12.8333806 15,13.2546893 L15,9 L9,9 L9,15 L13.2546893,15 C12.8333806,15.6040072 12.5048858,16.2775651 12.2898787,17 Z M17,7 L22,7 L22,5 C22,3.34314575 20.6568542,2 19,2 L17,2 L17,7 Z M15,7 L15,2 L9,2 L9,7 L15,7 Z M7,2 L5,2 C3.34314575,2 2,3.34314575 2,5 L2,7 L7,7 L7,2 Z M2,9 L2,15 L7,15 L7,9 L2,9 Z M2,17 L2,19 C2,20.6568542 3.34314575,22 5,22 L7,22 L7,17 L2,17 Z" />
                            </svg>
                        </v-btn>

                        <v-btn :disabled="!isActive.table() || !editable" @click="commands.addColumnBefore(), emitInput()" class="bar_button">
                            <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 24 24">
                                <path :fill="editable ? 'rgba(0,0,0,1)' : 'rgba(0,0,0,0.26)'" d="M19,14 C21.7600532,14.0033061 23.9966939,16.2399468 24,19 C24,21.7614237 21.7614237,24 19,24 C16.2385763,24 14,21.7614237 14,19 C14,16.2385763 16.2385763,14 19,14 Z M21.5,19.9375 C22.017767,19.9375 22.4375,19.517767 22.4375,19 C22.4375,18.482233 22.017767,18.0625 21.5,18.0625 L20.25,18.0625 C20.077411,18.0625 19.9375,17.922589 19.9375,17.75 L19.9375,16.5 C19.9375,15.982233 19.517767,15.5625 19,15.5625 C18.482233,15.5625 18.0625,15.982233 18.0625,16.5 L18.0625,17.75 C18.0625,17.922589 17.922589,18.0625 17.75,18.0625 L16.5,18.0625 C15.982233,18.0625 15.5625,18.482233 15.5625,19 C15.5625,19.517767 15.982233,19.9375 16.5,19.9375 L17.75,19.9375 C17.922589,19.9375 18.0625,20.077411 18.0625,20.25 L18.0625,21.5 C18.0625,22.017767 18.482233,22.4375 19,22.4375 C19.517767,22.4375 19.9375,22.017767 19.9375,21.5 L19.9375,20.25 C19.9375,20.077411 20.077411,19.9375 20.25,19.9375 L21.5,19.9375 Z M2,19 C2,20.6568542 3.34314575,22 5,22 C6.65685425,22 8,20.6568542 8,19 L8,5 C8,3.34314575 6.65685425,2 5,2 C3.34314575,2 2,3.34314575 2,5 L2,19 Z M-2.7585502e-16,19 L5.81397739e-16,5 C-1.37692243e-16,2.23857625 2.23857625,0 5,0 C7.76142375,0 10,2.23857625 10,5 L10,19 C10,21.7614237 7.76142375,24 5,24 C2.23857625,24 4.43234962e-16,21.7614237 -2.7585502e-16,19 Z" />
                            </svg>
                        </v-btn>

                        <v-btn :disabled="!isActive.table() || !editable" @click="commands.addColumnAfter(), emitInput()" class="bar_button">
                            <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 24 24">
                                <path :fill="editable ? 'rgba(0,0,0,1)' : 'rgba(0,0,0,0.26)'" d="M5,14 C7.76005315,14.0033061 9.99669388,16.2399468 10,19 C10,21.7614237 7.76142375,24 5,24 C2.23857625,24 1.77635684e-15,21.7614237 1.77635684e-15,19 C1.77635684e-15,16.2385763 2.23857625,14 5,14 Z M7.5,19.9375 C8.01776695,19.9375 8.4375,19.517767 8.4375,19 C8.4375,18.482233 8.01776695,18.0625 7.5,18.0625 L6.25,18.0625 C6.07741102,18.0625 5.9375,17.922589 5.9375,17.75 L5.9375,16.5 C5.9375,15.982233 5.51776695,15.5625 5,15.5625 C4.48223305,15.5625 4.0625,15.982233 4.0625,16.5 L4.0625,17.75 C4.0625,17.922589 3.92258898,18.0625 3.75,18.0625 L2.5,18.0625 C1.98223305,18.0625 1.5625,18.482233 1.5625,19 C1.5625,19.517767 1.98223305,19.9375 2.5,19.9375 L3.75,19.9375 C3.92258898,19.9375 4.0625,20.077411 4.0625,20.25 L4.0625,21.5 C4.0625,22.017767 4.48223305,22.4375 5,22.4375 C5.51776695,22.4375 5.9375,22.017767 5.9375,21.5 L5.9375,20.25 C5.9375,20.077411 6.07741102,19.9375 6.25,19.9375 L7.5,19.9375 Z M16,19 C16,20.6568542 17.3431458,22 19,22 C20.6568542,22 22,20.6568542 22,19 L22,5 C22,3.34314575 20.6568542,2 19,2 C17.3431458,2 16,3.34314575 16,5 L16,19 Z M14,19 L14,5 C14,2.23857625 16.2385763,0 19,0 C21.7614237,0 24,2.23857625 24,5 L24,19 C24,21.7614237 21.7614237,24 19,24 C16.2385763,24 14,21.7614237 14,19 Z" />
                            </svg>
                        </v-btn>

                        <v-btn :disabled="!isActive.table() || !editable" @click="commands.deleteColumn(), emitInput()" class="bar_button">
                            <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 24 24">
                                <path :fill="editable ? 'rgba(0,0,0,1)' : 'rgba(0,0,0,0.26)'" d="M12.6414391,21.9312708 C12.9358807,22.5689168 13.3234155,23.1547532 13.7866134,23.6713497 C13.2317936,23.8836754 12.6294813,24 12,24 C9.23857625,24 7,21.7614237 7,19 L7,5 C7,2.23857625 9.23857625,0 12,0 C14.7614237,0 17,2.23857625 17,5 L17,12.2898787 C16.2775651,12.5048858 15.6040072,12.8333806 15,13.2546893 L15,5 C15,3.34314575 13.6568542,2 12,2 C10.3431458,2 9,3.34314575 9,5 L9,19 C9,20.6568542 10.3431458,22 12,22 C12.220157,22 12.4347751,21.9762852 12.6414391,21.9312708 Z M19,14 C21.7600532,14.0033061 23.9966939,16.2399468 24,19 C24,21.7614237 21.7614237,24 19,24 C16.2385763,24 14,21.7614237 14,19 C14,16.2385763 16.2385763,14 19,14 Z M16.5,19.9375 L21.5,19.9375 C22.017767,19.9375 22.4375,19.517767 22.4375,19 C22.4375,18.482233 22.017767,18.0625 21.5,18.0625 L16.5,18.0625 C15.982233,18.0625 15.5625,18.482233 15.5625,19 C15.5625,19.517767 15.982233,19.9375 16.5,19.9375 Z" />
                            </svg>
                        </v-btn>

                        <v-btn :disabled="!isActive.table() || !editable" @click="commands.addRowBefore(), emitInput()" class="bar_button">
                            <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 24 24">
                                <path :fill="editable ? 'rgba(0,0,0,1)' : 'rgba(0,0,0,0.26)'" d="M19,14 C21.7600532,14.0033061 23.9966939,16.2399468 24,19 C24,21.7614237 21.7614237,24 19,24 C16.2385763,24 14,21.7614237 14,19 C14,16.2385763 16.2385763,14 19,14 Z M21.5,19.9375 C22.017767,19.9375 22.4375,19.517767 22.4375,19 C22.4375,18.482233 22.017767,18.0625 21.5,18.0625 L20.25,18.0625 C20.077411,18.0625 19.9375,17.922589 19.9375,17.75 L19.9375,16.5 C19.9375,15.982233 19.517767,15.5625 19,15.5625 C18.482233,15.5625 18.0625,15.982233 18.0625,16.5 L18.0625,17.75 C18.0625,17.922589 17.922589,18.0625 17.75,18.0625 L16.5,18.0625 C15.982233,18.0625 15.5625,18.482233 15.5625,19 C15.5625,19.517767 15.982233,19.9375 16.5,19.9375 L17.75,19.9375 C17.922589,19.9375 18.0625,20.077411 18.0625,20.25 L18.0625,21.5 C18.0625,22.017767 18.482233,22.4375 19,22.4375 C19.517767,22.4375 19.9375,22.017767 19.9375,21.5 L19.9375,20.25 C19.9375,20.077411 20.077411,19.9375 20.25,19.9375 L21.5,19.9375 Z M5,2 C3.34314575,2 2,3.34314575 2,5 C2,6.65685425 3.34314575,8 5,8 L19,8 C20.6568542,8 22,6.65685425 22,5 C22,3.34314575 20.6568542,2 19,2 L5,2 Z M5,0 L19,0 C21.7614237,-5.07265313e-16 24,2.23857625 24,5 C24,7.76142375 21.7614237,10 19,10 L5,10 C2.23857625,10 3.38176876e-16,7.76142375 0,5 C-1.2263553e-15,2.23857625 2.23857625,5.07265313e-16 5,0 Z" />
                            </svg>
                        </v-btn>

                        <v-btn :disabled="!isActive.table() || !editable" @click="commands.addRowAfter(), emitInput()" class="bar_button">
                            <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 24 24">
                                <path :fill="editable ? 'rgba(0,0,0,1)' : 'rgba(0,0,0,0.26)'" d="M19,0 C21.7600532,0.00330611633 23.9966939,2.23994685 24,5 C24,7.76142375 21.7614237,10 19,10 C16.2385763,10 14,7.76142375 14,5 C14,2.23857625 16.2385763,0 19,0 Z M21.5,5.9375 C22.017767,5.9375 22.4375,5.51776695 22.4375,5 C22.4375,4.48223305 22.017767,4.0625 21.5,4.0625 L20.25,4.0625 C20.077411,4.0625 19.9375,3.92258898 19.9375,3.75 L19.9375,2.5 C19.9375,1.98223305 19.517767,1.5625 19,1.5625 C18.482233,1.5625 18.0625,1.98223305 18.0625,2.5 L18.0625,3.75 C18.0625,3.92258898 17.922589,4.0625 17.75,4.0625 L16.5,4.0625 C15.982233,4.0625 15.5625,4.48223305 15.5625,5 C15.5625,5.51776695 15.982233,5.9375 16.5,5.9375 L17.75,5.9375 C17.922589,5.9375 18.0625,6.07741102 18.0625,6.25 L18.0625,7.5 C18.0625,8.01776695 18.482233,8.4375 19,8.4375 C19.517767,8.4375 19.9375,8.01776695 19.9375,7.5 L19.9375,6.25 C19.9375,6.07741102 20.077411,5.9375 20.25,5.9375 L21.5,5.9375 Z M5,16 C3.34314575,16 2,17.3431458 2,19 C2,20.6568542 3.34314575,22 5,22 L19,22 C20.6568542,22 22,20.6568542 22,19 C22,17.3431458 20.6568542,16 19,16 L5,16 Z M5,14 L19,14 C21.7614237,14 24,16.2385763 24,19 C24,21.7614237 21.7614237,24 19,24 L5,24 C2.23857625,24 3.38176876e-16,21.7614237 0,19 C-1.2263553e-15,16.2385763 2.23857625,14 5,14 Z" />
                            </svg>
                        </v-btn>

                        <v-btn :disabled="!isActive.table() || !editable" @click="commands.deleteRow(), emitInput()" class="bar_button">
                            <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 24 24">
                                <path :fill="editable ? 'rgba(0,0,0,1)' : 'rgba(0,0,0,0.26)'" d="M13.2546893,15 C12.8333806,15.6040072 12.5048858,16.2775651 12.2898787,17 L5,17 C2.23857625,17 3.38176876e-16,14.7614237 0,12 C-1.2263553e-15,9.23857625 2.23857625,7 5,7 L19,7 C21.7614237,7 24,9.23857625 24,12 C24,12.6294813 23.8836754,13.2317936 23.6713497,13.7866134 C23.1547532,13.3234155 22.5689168,12.9358807 21.9312708,12.6414391 C21.9762852,12.4347751 22,12.220157 22,12 C22,10.3431458 20.6568542,9 19,9 L5,9 C3.34314575,9 2,10.3431458 2,12 C2,13.6568542 3.34314575,15 5,15 L13.2546893,15 Z M19,14 C21.7600532,14.0033061 23.9966939,16.2399468 24,19 C24,21.7614237 21.7614237,24 19,24 C16.2385763,24 14,21.7614237 14,19 C14,16.2385763 16.2385763,14 19,14 Z M16.5,19.9375 L21.5,19.9375 C22.017767,19.9375 22.4375,19.517767 22.4375,19 C22.4375,18.482233 22.017767,18.0625 21.5,18.0625 L16.5,18.0625 C15.982233,18.0625 15.5625,18.482233 15.5625,19 C15.5625,19.517767 15.982233,19.9375 16.5,19.9375 Z" />
                            </svg>
                        </v-btn>
                    </div>
                </div>

            </div>

        </div>
    </editor-menu-bar>

    <editor-content :editor="editor" :editable="editable" spellcheck="false" @input.native="emitInput" @keyup.delete.native="emitInput" @paste.native="emitInput" @cut.native="emitInput" class="editor__content pa-2 ma-2" style="overflow-y: auto; max-height: 300px;"
        @click.native="editor.focus()" />

</v-card>
</template>

<script>
import {
    Editor,
    EditorContent,
    EditorMenuBar
} from 'tiptap'
import {
    Blockquote,
    BulletList,
    CodeBlock,
    HardBreak,
    Heading,
    History,
    OrderedList,
    ListItem,
    TodoItem,
    TodoList,
    Bold,
    Code,
    Italic,
    Link,
    Strike,
    Underline,
    Table,
    TableHeader,
    TableCell,
    TableRow,
    Placeholder,
} from 'tiptap-extensions'

export default {

    components: {
        EditorContent,
        EditorMenuBar
    },

    props: {
        value: {
            type: String,
            default: null
        },
        editable: {
            type: Boolean,
            default: true
        },
        placeholder: {
            type: String,
            default: 'Write something …'
        }
    },

    data() {
        return {
            focus_value: true,
            linkUrl: null,
            linkMenuIsActive: false,
            html: null,

            editor: new Editor({
                content: this.value,
                extensions: [
                    new Blockquote(),
                    new BulletList(),
                    new CodeBlock(),
                    new HardBreak(),
                    new Heading({
                        levels: [1, 2, 3, 4, 5]
                    }),
                    new History(),
                    new ListItem(),
                    new OrderedList(),
                    new TodoItem(),
                    new TodoList(),
                    new Bold(),
                    new Code(),
                    new Italic(),
                    new Link(),
                    new Strike(),
                    new Underline(),
                    new Table(),
                    new TableHeader(),
                    new TableCell(),
                    new TableRow(),
                    new Placeholder({
                        emptyNodeClass: 'is-empty',
                        emptyNodeText: this.placeholder,
                        showOnlyWhenEditable: true,
                    }),
                ],
            })
        }
    },

    created() {
        this.editor.options.editable = this.editable;
        this.editor.setContent(this.value);

    },

    watch: {

        value: {
            handler(newValue, oldValue) {
                if(oldValue === null) {
                    if(newValue === null) {
                        this.editor.setContent("");
                    } else {
                        this.editor.setContent(newValue);
                    }
                }
                if(newValue === null) {
                    this.editor.setContent("");
                }
            }
        },

        editable: {
            handler() {
                this.editor.setOptions({
                    editable: this.editable
                })
                if(this.editable) {
                    this.editor.focus()
                }
            }
        },

        placeholder: {
            handler() {
                this.editor.extensions.options.placeholder.emptyNodeText = this.placeholder;
            }
        },
        html: {
            handler() {
                this.$emit("update", this.html);
            }
        }
    },

    methods: {

        emitInput() {
            this.$emit('input', this.editor.getHTML())

        },

        clearContent() {
            this.editor.clearContent(true)
            this.editor.focus()
        },

        showLinkMenu(attrs) {
            this.linkUrl = attrs.href;
            this.linkMenuIsActive = true;
        },

        hideLinkMenu() {
            this.linkUrl = null;
            this.linkMenuIsActive = false;
        },

        setLinkUrl(command, url) {
            command({
                href: url
            });
            this.hideLinkMenu();
            this.editor.focus();
        },

    }

}
</script>

<style>
.editor__content p.is-empty:first-child::before {
    content: attr(data-empty-text);
    float: left;
    color: #aaa;
    pointer-events: none;
    height: 0;
    font-style: italic;
}

.bar_button {
    min-width: 28px !important;
    max-width: 28px !important;
    height: 28px !important;
    margin: 0.1rem 0.1rem !important;
}

.ProseMirror:focus {
    outline-style: none;
}

.editor__content table {
    border-collapse: collapse;
    table-row: fixed;
    width: 100%;
    margin: 0;
    overflow: hidden
}

.editor__content table td,
.editor__content table th {
    min-width: 1em;
    border: 2px solid #ddd;
    padding: 3px 5px;
    vertical-align: top;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: relative
}

.editor__content table td>*,
.editor__content table th>* {
    margin: 0
}

.editor__content table .column-resize-handle {
    position: absolute;
    right: -2px;
    top: 0;
    bottom: 0;
    width: 4px;
    background-color: #adf;
    cursor: col-resize;
}

.editor__content .tableWrapper {
    margin: 1em 0;
    overflow-x: auto
}

.drop-down {
    max-height: 0px;
    transition: max-height 0.7s ease-out;
    overflow: hidden;
}

.drop-down.open {
    max-height: 62px;
    transition: max-height 0.30 ease-in;
}
</style>
